import type { IconProps } from './types';

export const DragIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.78646 8.14286C10.2066 8.14286 11.3579 6.99159 11.3579 5.57143C11.3579 4.15127 10.2066 3 8.78646 3C7.36629 3 6.21503 4.15127 6.21503 5.57143C6.21503 6.99159 7.36629 8.14286 8.78646 8.14286ZM8.78646 14.5714C10.2066 14.5714 11.3579 13.4202 11.3579 12C11.3579 10.5798 10.2066 9.42857 8.78646 9.42857C7.36629 9.42857 6.21503 10.5798 6.21503 12C6.21503 13.4202 7.36629 14.5714 8.78646 14.5714ZM11.3579 18.4286C11.3579 19.8488 10.2066 21 8.78646 21C7.36629 21 6.21503 19.8488 6.21503 18.4286C6.21503 17.0084 7.36629 15.8571 8.78646 15.8571C10.2066 15.8571 11.3579 17.0084 11.3579 18.4286ZM15.215 8.14286C16.6352 8.14286 17.7865 6.99159 17.7865 5.57143C17.7865 4.15127 16.6352 3 15.215 3C13.7949 3 12.6436 4.15127 12.6436 5.57143C12.6436 6.99159 13.7949 8.14286 15.215 8.14286ZM17.7865 12C17.7865 13.4202 16.6352 14.5714 15.215 14.5714C13.7949 14.5714 12.6436 13.4202 12.6436 12C12.6436 10.5798 13.7949 9.42857 15.215 9.42857C16.6352 9.42857 17.7865 10.5798 17.7865 12ZM15.215 21C16.6352 21 17.7865 19.8488 17.7865 18.4286C17.7865 17.0084 16.6352 15.8571 15.215 15.8571C13.7949 15.8571 12.6436 17.0084 12.6436 18.4286C12.6436 19.8488 13.7949 21 15.215 21Z"
        fill={color}
      />
    </svg>
  );
};
